import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { ConfiguracionFincaService } from "../../../../generated/grpc/configuracion_finca_pb";
import {
  fromClienteFincaBaseResponse,
  grpcFincaLoteDatabase,
  toClienteFincaBaseResponseFromConfiguracionItem,
} from "../../../terceros/database/GrpcFincaLoteDatabase";
import { ClienteFincaBaseResponse } from "../../../terceros/response/ClienteFincaBaseResponse";
import { FincaGanaderiaRequest } from "../request/FincaGanaderiaRequest";

/** Servicio de guardado de la configuración de ganadería de una finca
 *  (`ConfiguracionFincaService.GuardarGanaderia`, gRPC-Web — antes
 *  `POST /configuracion/fincas-ganaderia/save`, ver CLAUDE.md del Server,
 *  sección migración a gRPC-Web). Devuelve la finca actualizada, persistida en
 *  `grpcFincaLoteDatabase` (`upsertFincaAsync`, la fuente real que hoy lee el
 *  sidebar — ver `ClienteAsideMenuRender`). */
export class FincaGanaderiaSaveService
  implements ISaveService<FincaGanaderiaRequest, ClienteFincaBaseResponse>
{
  async saveAsync(request: FincaGanaderiaRequest): Promise<ClienteFincaBaseResponse> {
    const client = createClient(ConfiguracionFincaService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.guardarGanaderia({
        fincaId: request.id,
        ganaderiaCrecimientoDiarioGr: request.ganaderiaCrecimientoDiarioGr,
        ganaderiaDiasDescansoOptimo: request.ganaderiaDiasDescansoOptimo,
        ganaderiaDiasOcupacionOptimo: request.ganaderiaDiasOcupacionOptimo,
        ganaderiaAnimalesXHectareaOptimo: request.ganaderiaAnimalesXHectareaOptimo,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    const item = toClienteFincaBaseResponseFromConfiguracionItem(saved);

    await grpcFincaLoteDatabase.upsertFincaAsync(fromClienteFincaBaseResponse(item));

    return item;
  }
}
